import graphql__9e86411c09fdc5b294bd from "./__generated__/TransferAppDestination_transferRequestDestination.graphql.ts";
import graphql__445201fbcbfeeda66ed9 from "./__generated__/TransferAppDestinationCancelMutation.graphql.ts";import { Alert, Button, MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import React, { useState } from 'react'
import { useFragment, useMutation } from 'react-relay/hooks'

import { TransferAppDestination_transferRequestDestination$key } from './__generated__/TransferAppDestination_transferRequestDestination.graphql'
import { TransferAppDestinationCancelMutation } from './__generated__/TransferAppDestinationCancelMutation.graphql'

const fragment = graphql__9e86411c09fdc5b294bd

const cancelTransferMutation = graphql__445201fbcbfeeda66ed9

type Props = {
  /** App ID */
  appId: string
  /** Destination entity */
  destination: TransferAppDestination_transferRequestDestination$key
  /** True if the user is allowed to cancel the transfer request. */
  canCancel: boolean
}

const TransferAppDestination: React.FC<Props> = ({
  destination,
  appId,
  canCancel,
}) => {
  const data = useFragment(fragment, destination)
  const [cancelTransferRequest, isCancelingTransferRequest] =
    useMutation<TransferAppDestinationCancelMutation>(cancelTransferMutation)
  const [cancelRequestError, setCancelRequestError] = useState<Error>()

  const handleCancelTransferRequest = () => {
    cancelTransferRequest({
      variables: { appId },
      onError: setCancelRequestError,
    })
  }

  const destinationTypeName =
    data?.__typename === 'Organization' ? 'organization' : 'user'

  const destinationName =
    data?.__typename === 'Organization'
      ? data.name
      : data.__typename === 'UserDestination'
        ? data.email
        : null

  return (
    <>
      {!!cancelRequestError && (
        <Alert
          variant="danger"
          autoDismiss={false}
        >{`Error cancelling the transfer request: ${cancelRequestError.message}`}</Alert>
      )}
      <MessagePanel
        variant="danger"
        message={() => (
          <>
            This app is pending transfer to {destinationTypeName}{' '}
            <span className="font-medium">{`"${destinationName}"`}</span>. If
            you want to cancel this request you must do so before the transfer
            is accepted by the recipient.
          </>
        )}
        className="mt-4 max-w-xl"
      />
      {!!canCancel && (
        <Button
          variant="critical"
          onClick={handleCancelTransferRequest}
          disabled={isCancelingTransferRequest}
          className="mt-8"
        >
          Cancel request
        </Button>
      )}
    </>
  )
}

export default TransferAppDestination
